import {
  faChevronLeft,
  faChevronRight,
  faCrown,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

import { useLanguage } from "../../contexts/LanguageContext";
import { formatDisplayDate } from "../../utils/dateUtils";

const DashboardSidebar = ({
  user,
  userEvents,
  sidebarCollapsed,
  setSidebarCollapsed,
  selectedEventId,
  setSelectedEventId,
  handleDeleteEvent,
  setIsPricingModalOpen,
}) => {
  const { t } = useLanguage();

  const handleEventSelect = (eventId) => {
    try {
      setSelectedEventId(eventId);
      localStorage.setItem("selectedEventId", eventId);

      // On mobile, don't auto-collapse the sidebar
      // Let the user manually control the sidebar state
    } catch (error) {
      console.error("Error selecting event:", error);
    }
  };

  const handleDeleteClick = (e, eventId) => {
    e.stopPropagation(); // Prevent event selection when clicking delete
    handleDeleteEvent(eventId);
  };

  return (
    <>
      <div className={`events-sidebar ${sidebarCollapsed ? "collapsed" : ""}`}>
        <div className="sidebar-header">
          <h3>{t("dashboard.sidebar.title")}</h3>
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            aria-label="Toggle sidebar"
          >
            <FontAwesomeIcon
              icon={sidebarCollapsed ? faChevronRight : faChevronLeft}
            />
          </button>
        </div>

        <div className="events-list">
          {userEvents?.map((evt) => (
            <div key={evt.id} className="event-item-wrapper">
              <div
                className={`event-item ${
                  evt.id === selectedEventId ? "active" : ""
                }`}
                onClick={() => handleEventSelect(evt.id)}
                style={{ cursor: "pointer" }}
              >
                <span className="event-monogram" aria-hidden="true">
                  {(evt.name || "E").trim().charAt(0).toUpperCase()}
                </span>
                <div className="event-item-content">
                  <div className="event-name">{evt.name}</div>
                  <div className="event-date">
                    {formatDisplayDate(evt.date)}
                  </div>
                  <div className="event-stats-small">
                    <span>
                      {evt.totalPhotos || 0} {t("dashboard.sidebar.photos")}
                    </span>
                  </div>
                </div>
              </div>
              {user?.isPremium && !sidebarCollapsed && (
                <button
                  className="delete-event-btn"
                  onClick={(e) => handleDeleteClick(e, evt.id)}
                  title={t("dashboard.sidebar.deleteEvent")}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              )}
            </div>
          ))}
        </div>

        <div className="sidebar-footer">
          {(!user.isPremium && userEvents?.length < 3) || user?.isPremium ? (
            <Link
              to="/create-event"
              className={`btn btn-primary btn-create-event ${sidebarCollapsed ? 'collapsed-button' : ''}`}
            >
              <FontAwesomeIcon icon={faPlus} />
              <span>{t("dashboard.sidebar.createEvent")}</span>
            </Link>
          ) : (
            <button
              className="btn-pro"
              style={{ width: "100%" }}
              onClick={() => setIsPricingModalOpen(true)}
            >
              <FontAwesomeIcon
                icon={faCrown}
                color="#9aa0ad"
                style={{ marginRight: "0.5rem" }}
              />
              {t("dashboard.sidebar.upgradeToPro")}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardSidebar;
